import React, { useState } from "react";
import "./Departments.css";

/* -------------------- SUBJECT LIST -------------------- */
const data = {
  ba: [
    "economics",
    "history",
    "political-science",
    "psychology",
    "public-administration"
  ],

  bba: [
    "business-regulations",
    "business-statistics",
    "consumer-behavior",
    "market-analysis",
    "organizational-behavior",
    "principles-of-management",
    "principles-of-marketing"
  ],

  bca: [
    "artificial-intelligence",
    "computer-architecture",
    "computer-networks",
    "data-structure",
    "database-management-system",
    "design-and-analysis-of-algorithms",
    "discrete-structures",
    "java",
    "machine-learning",
    "mobile-application-development",
    "office-automation-tools",
    "operating-systems",
    "problem-solving-techniques",
    "quantitative-techniques",
    "software-engineering",
    "software-testing"
  ],

  bcom: [
    "advanced-accounting",
    "advanced-financial-accounting",
    "auditing",
    "banking-and-insurance",
    "banking-and-business-environment",
    "business-regulations",
    "corporate-accounting",
    "corporate-administration",
    "cost-accounting",
    "costing-methods",
    "financial-accounting-and-reporting",
    "financial-management",
    "goods-and-service-tax",
    "human-resource-management",
    "income-tax-1-and-2",
    "indian-accounting-standards",
    "principles-of-marketing"
  ],

  bsc: []
};

/* -------------------- FILE STRUCTURE -------------------- */
const files = {

  /* ---------- BA ---------- */
  ba: {
    "economics": {
      studymaterials: [
        "Economics of human development.pdf",
         "Managerial Economics IMP.pdf", 
         "NOTES-MANAGERIAL ECONOMICS.pdf", 
         "rural-economics notes.pdf",
        "rural-economics.pdf"
      ],
      qps: [
        "4th sem B.com & BBA Rural Economics NEP Sept 2023.pdf", 
        "economics of business environment (OEEC211)2ND Sem oct-22.pdf", 
        "IV SEM NEP OE ECONOMICS OEEC312.pdf", 
        "IV Sem Open Elective (Rural Economics).pdf"]
    },
    "history": {
      studymaterials: [
        "HISTORY DSC 10 (1).pdf", 
        "HISTORY DSC 10 (2).pdf", 
        "HISTORY DSC 10 (3).pdf", 
        "HISTORY DSC 10 (4).pdf"],
      qps: ["", "", "", ""]
    },
    "political-science": {
      studymaterials: ["", "", "", ""],
      qps: [
        "2nd semester political science 2019.pdf",
         "5th semester Political science question papers.pdf",
          "Political Science 3rd Sem.pdf", ""]
    },
    "psychology": {
      studymaterials: [
        "IV SEM NEP OE PSYCHOLOGY 2023.pdf", 
        "Psychology and Mental Health_IV Sem.pdf",
         "Psychology Health and Well Being 1st Sem.pdf"
         ],
      qps: [
        "IV SEM NEP OE PSYCHOLOGY 2023.pdf",
         "Psychology Health and Well Being 1st Sem.pdf"
        ]
    },
    "public-administration": {
      studymaterials: ["", "", "", ""],
      qps: [
        "Public Administration in Business.pdf"
      ]
    }
  },

  /* ---------- BBA ---------- */
  bba: {
    "business-regulations": {
      studymaterials: [ 
        "Business_Regulations_calicutUni.pdf", "", ""],
      qps: [
         "Business_Regulations_calicutUni.pdf",
          "Business-Regulation.pdf",
           "Business-Regulations.pdf"]
    },
    "business-statistics": {
      studymaterials: [
        "Business statistics (Evershine).pdf", "", "", ""],
      qps: [
        "Business Statistics -3rd sem b.com NEP 2023.pdf",
        "Business Statistics 3rd Sem B.Com.pdf",
         "Statistics For Business Decision 3rd Sem BBA.pdf",
          "Statistics for business decisions- 3rd sem BBA 2023.pdf", ""]
    },
    "consumer-behavior": {
      studymaterials: [
        "consumer-behaviour (3).pdf", "", "", ""],
      qps: [
        "5 SEM BCOM APRIL 2022 CONSUMER BEHAVIOUR AND MARKEING RESEAR.pdf", 
        "Consumer-Behaviour.pdf", 
        "", ""]
    },
    "market-analysis": {
      studymaterials: [
        "Marketing-Analysis-Data-Driven-Techniques-with-Microsoft-Exc.pdf", 
        "UNIT-1_INTRODUCTION-TO-MARKETING-ANALYTICS-AND-DATA-MINING_L.pdf", 
        "UNIT-5_APPLICATION-OF-ANALYTICS-IN-MARKETING_Lecture-Notes.-.pdf"
      ],
      qps: ["", "", "", ""]
    },
    "organizational-behavior": {
      studymaterials: [
        "6th_sem_BBA_Organizational_Development_&_Change_Mgt_Sept_202.pdf", 
        "Organizational Behaviour 3rd Sem BBA (2).pdf",
         "Organizational Behaviour 3rd Sem BBA.pdf", ""],
      qps: ["", "", "", ""]
    },
    "principles-of-management": {
      studymaterials: [
        "principles-of-management (2).pdf",
         "Principles-Of-Managment chapter 1.pdf"
        ],
      qps: [
        "Principles-of-Management.pdf"
      ]
    },
    "principles-of-marketing": {
      studymaterials: [
        "Principles of Marketing Kannada Medium Notes.pdf", 
        "Principles of Marketing.pdf", 
        "", ""],
      qps: [
        "Principles of Marketing2022.pdf", 
        "Principles of Marketing2023.pdf", "", ""]
    }
  },

  /* ---------- BCA ---------- */
  bca: {
    "artificial-intelligence": { studymaterials: [
      "AI TEXTBOOK.pdf", 
      "AI UNIT 1.pdf",
       "AI UNIT2.pdf",
        "AI -UNIT3.pdf"], qps: [
          "Ai model question paper-1.pdf", 
          "Ai model question paper-2.pdf", 
          "Ai Solved Question Paper 2024.pdf"] },
    "computer-architecture": { studymaterials: ["", "", "", ""], qps: [
        "Computer Architecture Solved Paper 2024 (2).pdf",
         "Computer_Architecture.pdf",
          "II Sem BCA(Computer (Applications) Architecture).pdf", ""] },
    "computer-networks": { studymaterials: [
      "Computer Networks 3rd Sem BCA.pdf", 
      "computer-networks.pdf",
       "computer-networks-notes.pdf", ""], 
       qps: ["computer-networks-question-bank.pdf"] },
    "data-structure": { studymaterials: [
      "DS_TEXTBOOK1.pdf"
    ],
     qps: [
      "4th Chapter DS Question Bank I Sem BCA.pdf",
       "DS model 2 solved.pdf",
        "DS-MODEL PAPER-1.pdf"] },
    "data-analytics":{ studymaterials: [
      "data-analytics-skywards.pdf"],
      qps: ["Data Analytics 5th Sem BCA.pdf"]},
    "database-management-system": { studymaterials: [
      "Unit-I_DBMS-1.pdf", 
      "Unit-II_DBMS.pdf",
       "Unit-III_DBMS.pdf", 
       "Unit-IV_DBMS.pdf",
      "DBMS_UNIT_V.pdf"], 
      qps: [
        "DBMS_Question_Bank.pdf",
         "DBMSModulequestions.pdf"] },
    "design-and-analysis-of-algorithms": { studymaterials: [
      "Analysis and Design of Algorithm material.pdf",
       "Design_and_Analysis_of_Algorithms_Notes_PDF_–_DAA_BCA_4th_se.pdf"], 
       qps: ["IV Sem BCA(Design and Analysis Of Algorithms).pdf", 
       ] },
    "discrete-structures": { studymaterials: [
      "Discrete Mathematical Structures MCA Module 3.pdf", 
      "discrete structures .pdf", 
      "Discrete tb Skyward.pdf", ""], qps: ["Discrete Structures 1st Sem BCA.pdf", "", "", ""] },
    "java": { studymaterials: [
      "java_unit_1.pdf",
       "java_unit_2.pdf", 
       "java_unit_3.pdf",
        "java_unit_4.pdf",
      "java_unit_5.pdf"], 
      qps: [
        "5 SEM BCA APRIL  2022 JAVA PROGRAMING.pdf", "", "", ""] },
    "machine-learning": { studymaterials: [
      "ml1.pdf", 
      "ml2.pdf",
       "ml3.pdf",
        "ml4.pdf"],
         qps: [
          "ML - Model Paper.pdf", 
          "MLQuestionBank.pdf", "", ""] },
    "mobile-application-development": { studymaterials: [
      "MAD Skyward.pdf", "", "", ""], 
      qps: [
        "MAD MQP.pdf", 
        "MAD_Model Question Paper_with_Answers_2.pdf", "", ""] },
    "office-automation-tools": { studymaterials: [
      "DF  ( office automation tools).pdf", "", "", ""],
       qps: ["", "", "", ""] },
    "operating-systems": { studymaterials: [
      "os1 (2).pdf", 
      "os2.pdf", 
      "os3.pdf",
       "os4.pdf",
      "os5t.pdf"], 
      qps: [
        "OS imp with answerrs.pdf",
         "OS Question Bank.pdf", "", ""] },
    "problem-solving-techniques": { studymaterials: [
      "Unit 1  PST using C.pdf", 
      "Unit 2  PST using C.pdf", 
      "Unit 3 PST using C.pdf", 
      "Unit 4 PST using C.pdf"],
       qps: [
        "PST-MODELPAPER-1.pdf", 
        "PST-MODELPAPER-2.pdf",
         "PST-QUESTION BANK (1).pdf", ""] },
    "quantitative-techniques": { studymaterials: [
      "QT Skyward.pdf", "", "", ""],
       qps: [
        "QT Model Paper Questions - 1.pdf",
         "QT Model Paper Questions with answers.docx.pdf", "", ""] },
    "software-engineering": { studymaterials: [
      "Software Engineering Skyward.pdf", "", "", ""], 
      qps: [
        "Software Engineering QP.pdf", "", "", ""] },
    "software-testing": { studymaterials: [
      "Software Testing Skyward.pdf", "", "", ""],
       qps: [
        "st-question-bank-software-testing.pdf", 
        "VI Sem BCA(Software Testing).pdf", "", ""] }
  },

  /* ---------- BCOM ---------- */
  bcom: {
    "advanced-accounting": { studymaterials: ["Advanced Accounting chapter 1 and 2.pdf",
       "Advanced Accounting chapter 3;4;5.pdf",
        "Advanced Accounting.pdf", ""], 
        qps: ["Advanced Accounting 2024 (2).pdf",
           "Advanced-Accounting-min.pdf", "", ""] },
    "advanced-financial-accounting": { studymaterials: ["AFA.pdf", "", "", ""],
       qps: ["AFA CHAPTER - WISE 2 MARKS .pdf",
         "AFA MQP SOLVED.pdf",
          "AFA Theory Question and Answers.pdf", ""] },
    "auditing": { studymaterials: [
      "Auditing and Assurance.pdf",
       "Auditing kannada.pdf", 
       "Auditing NEP 1st unit .pdf", ""],
        qps: ["Auditing 2 marks question and answers..pdf", 
          "AUDITING ALL 6 PREVIOUS YEAR QUESTION PAPERS.pdf",
           "Principles-and-Practice-of-Auditing.pdf", ""] },
    "banking-and-insurance": { studymaterials: ["", "", "", ""], 
      qps: ["Banking-And-Insurance-min 2017.pdf",
         "Banking-And-Insurance-min.pdf", 
         "Banking-And-Insurance-V 2012.pdf", ""] },
    "banking-and-business-environment": { studymaterials: [
      "BE Unit 1.pdf",
       "BE Unit 2.pdf",
        "BE Unit 3.pdf",
         "BE Unit 4.pdf",
        "BE Unit 5.pdf"], 
        qps: ["BE Important Questions.pdf",
           "economics of business environment (OEEC211)2ND Sem oct-22.pdf", 
           "II Sem BBA(Business Environment).pdf", ""] },
    "business-regulations": { studymaterials: [
      "Business_Regulations_calicutUni.pdf", 
      "", 
      "", ""], qps: [
        "Business-Regulation.pdf", 
        "Bba 5th sem business regulations (F+R).pdf", "", ""] },
    "corporate-accounting": { studymaterials: [
      "Corporate Accounting Geektonight .pdf",
       "Corporate Accounts .pdf", "", ""],
        qps: ["4th sem B.com Advanced Corporate Accounting NEP Sept 2023.pdf", 
          "IV Sem B.Com(Advanced Corporate Accounting).pdf", "", ""] },
    "corporate-administration": { studymaterials: ["Corporate Administration Kannada.pdf", 
      "corporate-administration-notes.pdf", "", ""], 
      qps: ["Corporate Administration ch 1,2 imp.pdf", 
        "II Sem B.Com(Corporate Administration).pdf", "", ""] },
    "cost-accounting": { studymaterials: ["Cost Accounting (Evershine).pdf", "", "", ""], 
      qps: ["Cost Accounting. 2024.pdf", 
        "Cost accounting 2023 QP solved.pdf", "", ""] },
    "costing-methods": { studymaterials: ["", "", "", ""], 
      qps: ["4th sem B.com Costing Methods & Techniques NEP Sept 2023.pdf",
         "5th sem bcom methods _ techniques of cost accounting (F).pdf", 
         "Costing Methods and Techniques.pdf",
          "IV Sem B.Com (Costing Methods and techniques).pdf"] },
    "financial-accounting-and-reporting": { studymaterials: [
      "Financial Accounting - BMS .pdf", 
      "financial-accounting-bcom-.pdf", "", ""],
       qps: ["Financial Accounting and Reporting 2023.pdf",
         "Financial Accounting Model Papers.pdf", 
         "II Sem BBA(Financial Accounting and Reporting) (2).pdf", ""] },
    "financial-management": { studymaterials: ["FINANCIAL MANAGEMENT-2024.pdf", "", "", ""],
       qps: ["Financial Accounting and Management.pdf", 
        "Financial-Accounting-and-Management-min 2017.pdf",
         "IV Sem BBA(Financial Management).pdf", ""] },
    "goods-and-service-tax": { studymaterials: ["GST.pdf", "", "", ""],
       qps: ["GST Practicals - Solved PYQP.pdf", 
        "GST QUESTIONS.pdf", 
        "gst solved.pdf", ""] },
    "human-resource-management": { studymaterials: ["U1 HRM.pdf",
       "U2 HRM.pdf",
        "U3 HRM.pdf",
         "U4 HRM.pdf",
        "U5 HRM.pdf"], 
        qps: ["HRM 2024.pdf",
           "human resource management (NEP) 2nd sem oct-22 .pdf",
            "Human Resource Management.pdf", ""] },
    "income-tax-1-and-2": { studymaterials: ["income tax 2.pdf", 
      "UNIT 1 INTRODUCTION TO INCOME TAX.pdf.crdownload.pdf", "", ""],
       qps: ["6th sem BBA Income Tax-II Sept 2023 .pdf",
         "Bba 5th sem income tax-1 (F+R).pdf", 
         "Bcom 5th income tax - 1 (F).pdf", 
         "INCOME TAX 2 MARKS .pdf",
        "Income-Tax-min 2017.pdf"] },
    "indian-accounting-standards": { studymaterials: ["IAS (2).pdf", 
      "IAS SKYWARD.pdf", "", ""],
       qps: ["IFRS & IAS QUESTION BANK.pdf", "", "", ""] },
    "principles-of-marketing": { studymaterials: ["Principles of Marketing Kannada Medium Notes.pdf",
       "Principles of Marketing.pdf", "", ""], qps: ["Principles of marketing- 1st sem b.com  NEP April 2023.pdf", "", "", ""] }
  }
};

/* -------------------- COMPONENT -------------------- */
export default function Departments() {
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const subjects = data[selectedDept] || [];
  const subjectFiles = files[selectedDept]?.[selectedSubject];


  return (
    <div className="container">

      {/* Intro - Displayed only when no department is selected */}
      {!selectedDept && (
        <div className="intro">
          <div className="welcome-card">
            <h1>BCU STUDY MATERIALS</h1>
            <p>
              Welcome! Access Study Materials and Question Papers for 
              <strong> BCA, BBA, BA, BCom and Bsc</strong> of 
              <strong> Dr. Manmohan Singh Bengaluru City University (BCU)</strong>.
            </p>
            <p className="instruction">Select your department below to get started.</p>
          </div>
        </div>
      )}

      {/* Departments Navigation */}
      <div className="dept-buttons">
        {Object.keys(data).map((dept) => (
          <button
            key={dept}
            className={selectedDept === dept ? "active-dept" : ""}
            onClick={() => {
              setSelectedDept(dept);
              setSelectedSubject("");
            }}
          >
            {dept.toUpperCase()}
          </button>
        ))}
      </div>

      {/* MAIN CONTENT */}
      {selectedDept && (
        <div className="main">

          {/* Subjects Sidebar */}
          <div className="sidebar">
            {subjects.length === 0 ? (
              <p className="no-data">WILL BE UPDATED SOON...</p>
            ) : (
              subjects.map((sub) => (
                <div
                  key={sub}
                  className={`subject ${selectedSubject === sub ? "active" : ""}`}
                  onClick={() => setSelectedSubject(sub)}
                >
                  {sub.replace(/-/g, " ").toUpperCase()}
                </div>
              ))
            )}
          </div>

          {/* Content Area */}
          <div className="content">
            {!selectedSubject ? (
              <div className="placeholder-text">
                <h2>Select a subject from the list</h2>
              </div>
            ) : !subjectFiles ? (
              <h2>Content not available</h2>
            ) : (
              <>
                <h2 className="subject-title">
                  {selectedSubject.replace(/-/g, " ").toUpperCase()}
                </h2>

                <div className="card">
                  <h3>📘 Study Materials</h3>
                  {subjectFiles.studymaterials.map((file, i) =>
                    file ? (
                      <a
                        key={i}
                        href={`/pdfs/${selectedDept}/${selectedSubject}/studymaterials/${file}`}
                        download
                        className="file-link"
                      >
                        👉 {file.replace(".pdf", "").replace(/[-_]/g, " ")}
                      </a>
                    ) : null
                  )}
                </div>

                <div className="card">
                  <h3>📄 Question Papers</h3>
                  {subjectFiles.qps.map((file, i) =>
                    file ? (
                      <a
                        key={i}
                        href={`/pdfs/${selectedDept}/${selectedSubject}/qps/${file}`}
                        target="_blank"
                        rel="noreferrer"
                        className="file-link"
                      >
                        👉 {file.replace(".pdf", "").replace(/[-_]/g, " ")}
                      </a>
                    ) : null
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}